import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { editCart } from 'bento-ordering/cart/actions/index';
import SeoTitleUpdater from 'components/SeoTitleUpdater';
import AllLocationsList from 'components/Location/AllLocationsList';
import LocationModalManager from 'bento-ordering/locations/containers/LocationModalManager';
import { selectLocationWithValidation } from 'bento-ordering/locations/actions/locations';
import NotificationModalContainer from 'bento-ordering/base/containers/NotificationModalContainer';
import LocationsCustomMessage from 'bento-ordering/locations/components/LocationsCustomMessage';
import PageLoadSpinner from 'components/PageLoadSpinner';
import { getCustomMessageSelector } from 'bento-ordering/account/reducers/index';
import {
  locationsThatDeliverToAddressSelector,
  locationsForPickupSelector,
  closedLocationsSelector,
  getSortedLocationsListSelector
} from 'bento-ordering/locations/selectors/';

import isDineInApplicationVariant from 'bento-ordering/utils/isDineInApplicationVariant';
import OnlineOrderingLocationCard from 'bento-ordering/locations/components/OnlineOrderingLocationCard';
import { GeocodeContext } from 'bento-ordering/context/GeocodeContext';

class LocationsContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    shouldOpenLocationDetailModal: PropTypes.bool,
    shouldOpenEditCartItemModal: PropTypes.bool,
    restaurantLocations: PropTypes.array,
    locationsThatDeliverToAddress: PropTypes.array,
    locationsForPickup: PropTypes.array,
    closedLocations: PropTypes.array,
    customMessage: PropTypes.string,
    googleLoaded: PropTypes.bool,
    isSettingAddress: PropTypes.bool
  };

  static defaultPropTypes = {
    shouldOpenLocationDetailModal: false,
    isSettingAddress: false
  };

  static contextType = GeocodeContext;

  state = {
    selectedMapLocation: null
  };

  beginOrder = (id, fulfillmentMethod) => {
    this.props.dispatch(selectLocationWithValidation(id, fulfillmentMethod));
  };

  setSelectedLocation = id => {
    const { dispatch } = this.props;

    dispatch(
      editCart({
        online_ordering_location: id
      })
    );
  };

  render() {
    const {
      shouldOpenLocationDetailModal,
      shouldOpenEditCartItemModal,
      restaurantLocations,
      customMessage,
      locationsThatDeliverToAddress,
      locationsForPickup,
      closedLocations,
      googleLoaded,
      isSettingAddress
    } = this.props;
    const { isMakingGeocodeRequest } = this.context;

    return (
      <>
        <SeoTitleUpdater section="Locations" />
        <NotificationModalContainer />
        <LocationModalManager
          shouldOpenLocationDetailModal={shouldOpenLocationDetailModal}
          shouldOpenEditCartItemModal={shouldOpenEditCartItemModal}
          setSelectedLocation={this.setSelectedLocation}
        />
        {!isDineInApplicationVariant() && customMessage && (
          <LocationsCustomMessage message={customMessage} />
        )}
        {restaurantLocations.isFetching ||
        !googleLoaded ||
        isSettingAddress ||
        isMakingGeocodeRequest ? (
          <PageLoadSpinner />
        ) : (
          <AllLocationsList
            selectedMapLocation={this.state.selectedMapLocation}
            beginOrder={this.beginOrder}
            restaurantLocations={restaurantLocations}
            locationsThatDeliverToAddress={locationsThatDeliverToAddress}
            locationsForPickup={locationsForPickup}
            closedLocations={closedLocations}
            shouldOpenLocationDetailModal={shouldOpenLocationDetailModal}
            LocationsListItemComponent={OnlineOrderingLocationCard}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSettingAddress: state.restaurantLocations.isSettingAddress,
    restaurantLocations: getSortedLocationsListSelector(
      state.restaurantLocations
    ),
    locationsThatDeliverToAddress: locationsThatDeliverToAddressSelector(
      state.restaurantLocations
    ),
    locationsForPickup: locationsForPickupSelector(state.restaurantLocations),
    closedLocations: closedLocationsSelector(state.restaurantLocations),
    customMessage: getCustomMessageSelector(state.account),
    modal: state.modal,
    locationSearch: state.locationSearch,
    locationDetail: state.locationDetail,
    googleLoaded: state.libraryLoad.google
  };
};

export default withRouter(connect(mapStateToProps)(LocationsContainer));
